import React, {useEffect, useState} from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../../Shared/TextInput/TextInput';
import {isMobile} from 'react-device-detect';

const StartScreen = (props) => {
  const [imeiNumber, setImei] = useState('');
  const [imeiError, setError] = useState(null);

  const disclaimerText = isMobile ? (
    <p className='disclaimerText'>
      *דינמיקה עושה את מירב המאמצים לספק את המידע <br />
      המעודכן והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו <br />
      מובטח כמדויק בכל עת. על מנת לבדוק אם מכשירך מתאים <br />
      ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  ) : (
    <p className='disclaimerText'>
      *דינמיקה עושה את מירב המאמצים לספק את המידע המעודכן והאמין <br />
      ביותר, אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל עת. על מנת <br />
      לבדוק אם מכשירך מתאים ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  );

  const imeiExplanation = isMobile ? (
    <p className='subHeading'>
      IMEI הינו קוד בן 15 ספרות שהינו המזהה הייחודי
      <br />
      של המכשיר. לצורך הבדיקה נדרש להכניס את
      <br />
      מספר ה-IMEI של המכשיר אותו ניתן למצוא <br />
      לאחר הקשה על #06#* בלוח המקשים
    </p>
  ) : (
    <p className='subHeading'>
      IMEI הינו קוד בן 15 ספרות שהינו המזהה הייחודי של המכשיר. לצורך <br />
      הבדיקה נדרש להכניס את מספר ה-IMEI של המכשיר <br />
      אותו ניתן למצוא לאחר הקשה על #06#* בלוח המקשים
    </p>
  );

  return (
    <>
      <div className='headBox'>
        <p className='heading'>
          מהו מספר ה-IMEI
          <br />
          של המכשיר שלך?
        </p>
        {imeiExplanation}
      </div>
      <div className='headBox'>
        <p className='subHeading'>אם מופיעים לך שני מספרי IMEI הזן את הראשון</p>
      </div>
      <TextInput
        placeholder={'מספר IMEI'}
        value={imeiNumber}
        style={{marginBottom: '32px'}}
        type='numeric'
        maxLength='15'
        error={imeiError}
        onChange={(e) => {
          e.persist();
          let digregex = /^\d+$/;
          if (digregex.test(e.target.value)) {
            setImei(e.target.value);
          }
        }}
      />
      <BtnSubmit
        onclick={() => {
          let digregex = /^\d+$/;

          if (imeiNumber == '') {
            setError('אנא הזן מספר IMEI');
          } else if (imeiNumber.length < 15 || !digregex.test(imeiNumber)) {
            setError('המספר שהוזן שגוי');
          } else {
            setError(null);
            props.checkImeiForVolte({imei: imeiNumber});
          }
        }}
        className='submitBtn mb-40'
        text='המשך'
      />
      {disclaimerText}
    </>
  );
};

export default StartScreen;
